import Vue from 'vue'
import log from 'loglevel'
import remote from 'loglevel-plugin-remote'
import pluralize from 'pluralize'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import VueHtmlToPaper from 'vue-html-to-paper'
import vuejsStorage from 'vuejs-storage'

import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import auth from './auth'
import { createProvider, setAuth } from './vue-apollo'
import vuetify from './plugins/vuetify'
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib'
import { getEnv } from './utilities'
import bubbleDirective from './directives/bubble-directive'
import { dateFilters } from './filters/date-filters'
import { yesNo, checkMark, cat, mask, percentage } from './filters/humanise'
import store, { mutations } from './store'

Vue.config.productionTip = false

// Remote Logging
log.setLevel(process.env.NODE_ENV === 'development' ? 'debug' : 'warn')
remote.apply(log, {
  url: getEnv('VUE_APP_LOG_HTTP'),
  interval: 10000,
  level: 'error',
  format: o => Object.assign(o, {
    level: o.level.label
  })
})

// Plugins
Vue.use(VueLodash, { lodash })
Vue.use(VueTelInputVuetify, {
  vuetify
})
Vue.use(VueHtmlToPaper, {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900',
    'https://cdn.jsdelivr.net/npm/@mdi/font@6.x/css/materialdesignicons.min.css',
    'https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css'
  ],
  timeout: 2000,
  autoClose: true
})
Vue.use(vuejsStorage)

// Directives
Vue.directive('bubble', bubbleDirective)
for (const key in dateFilters) {
  Vue.filter(key, dateFilters[key])
}

// Filters
Vue.filter('pluralize', pluralize)
Vue.filter('yesNo', yesNo)
Vue.filter('checkMark', checkMark)
Vue.filter('cat', cat)
Vue.filter('mask', mask)
Vue.filter('percentage', percentage)

// Authentication events from vue-oidc-client
auth.events.addUserLoaded(function setApolloAuth (user) {
  const authentication = `${user.token_type} ${user.access_token}`
  setAuth(authentication)
  log.debug('Apollo authentication set.', { authentication })
})

auth.events.addUserLoaded(function setInitialSelectedMember (user) {
  const { selectedMemberNumber } = store.state

  // Get all linked members with member numbers
  const memberNumbers = (user.profile?.members ?? []).map(o => o.memberNumber).filter(v => !!v)

  // Ensure selected member number is valid for the current user.
  const isValidMemberNumber = memberNumbers.includes(selectedMemberNumber)
  if (!isValidMemberNumber) store.commit(mutations.SET_SELECTED_MEMBER_NUMBER, null) // Clear selected member number if user doesn't have rights to it.

  if (selectedMemberNumber) return // Prevent overwriting value when tokens are refreshed.
  if (!memberNumbers.length) return // If no members do not try set one

  // Set initial selected member number from the selected value from the ID token, or fallback to first in list.
  const memberNumber = user.profile.selectedMemberNumber || memberNumbers[0]
  store.commit(mutations.SET_SELECTED_MEMBER_NUMBER, memberNumber)
  log.debug('Inital member number selected.', { memberNumber })
})

auth.events.addUserUnloaded(handleSignOut)
function handleSignOut () {
  store.commit(mutations.SET_SELECTED_MEMBER_NUMBER, null)
  log.debug('User signed out.')
}

// Custom vue prototype bindings
Vue.prototype.$auth = auth

// Start application
auth.startup().then(ok => {
  if (ok) {
    new Vue({
      router,
      vuetify,
      apolloProvider: createProvider(),
      store,
      render: h => h(App)
    }).$mount('#app')
  } else {
    console.error('Failed to configure authentication.')
  }
})
